<template>
  <div class="box">
    <Breadcrumb class="navigation">
      <BreadcrumbItem v-for="item in breadMenuData"
        :to="item.path">
        {{ item.name }}
      </BreadcrumbItem>
    </Breadcrumb>
    <div class="business-introduce-box">
      <p class="tit">1. {{ $t('key1006700') }}</p>
      <p class="sp">{{ $t('key1006701') }} </p>
      <p class="sp">{{ $t('key1006702') }}</p>
      <p class="sp1">{{$t('key1006687')+ configCharacters() + $t('key1006688')}}</p>
      <p class="sp1">{{ $t('key1006703') }}//www.tongtool.com/）授权开通。</p>
      <p class="sp1">{{ $t('key1006704') }}</p>
      <p class="sp1">② {{ $t('key1006705') }}</p>
      <p class="sp1">{{ $t('key1006689') + configCharacters() + $t('key1006690')}}</p>
      <p class="sp1">③ {{ $t('key1006706') }}</p>
      <p class="sp1">{{ $t('key1006691') + configCharacters() + $t('key1006692')}}</p>
      <p class="tit">2. {{ $t('key1006707') }}</p>
      <p class="sp">{{$t('key1006693')+ configCharacters() + $t('key1006694')}}</p>
      <p class="sp">{{ $t('key1006702') }}</p>
      <p class="sp1">① {{ $t('key1006708') }}</p>
      <p class="sp1">② {{ $t('key1006709') }}</p>
      <p class="tit">3. {{ $t('key1006710') }}</p>
      <p class="sp">{{ $t('key1006695') + configCharacters() + $t('key1006696')}}</p>
      <p class="sp">{{ $t('key1006702') }}</p>
      <p class="sp1">{{' ① '+ configCharacters() + $t('key1006697')}}</p>
      <p class="sp1">{{ $t('key1006698') + configCharacters() + $t('key1006699')}}</p>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';

export default {
  name: 'businessIntroduce',
  mixins: [Mixin],
  data () {
    return {
      breadMenuData: [{
        path: '/index',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562')
      },{
        path: '/businessIntroduce',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006686')
      }]
    };
  },
  created () {

  },
  props: {},
  watch: {},
  methods: {}
};
</script>

<style scoped lang="less">
.box {
  width: 1200px;
  margin: 0 auto;
  .navigation {
    padding: 10px;
  }
  .business-introduce-box {
    background-color: #ffffff;
    margin-bottom: 20px;
    padding: 24px 32px 24px 32px;
    line-height: 32px;
    color: #000000;
    .tit {
      font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
      font-weight: 700;
      margin-top: 30px;
    }
    .tit:first-child{
      margin-top: 0;
    }
    .sp1 {
      padding-left: 18px;
    }
  }
}
</style>
